export function containsAnyParam(searchQuery: string, params: string[]): boolean {
	if (searchQuery.length === 0) return false;

	for (const param of params) {
		if (param.length > 0 && searchQuery.includes(param)) {
			return true;
		}
	}
	return false;
}
